<template>
    <div class="discount">
        <p class="smallTitle"><span class="couponA">{{$t('discount')}}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="integralA" @click="goTocoupon()">积分</span></p>
        <div class="discount_count">
            <h1>{{couponNum}}<span>{{$t('piece')}}</span></h1>
            <small>{{$t('discount')}}</small>
        </div>
        <discountCoupon></discountCoupon>
    </div>
</template>

<script>
import discountCoupon from "../../components/personalCenter/discountCoupon";
export default {
  name: "discount",
  data: function() {
    return {
      couponNum: "" //优惠卷的张数
    };
  },
  inject: ["showMsg"],
  components: {
    discountCoupon
  },
  created() {
    this.$store.commit("set_current", "-1");
    this.getCouponsInfo(0);
    this.$store.commit("set_title", "card_bag");
  },
  computed: {
    weburl: function() {
      return this.$store.state.weburl;
    },
    hurl: function() {
      return this.$store.state.hurl;
    }
  },
  methods: {
    // 去购物卷
    goTocoupon: function() {
      this.$router.push({ path: "/exchangeDiscount" });
    },

    // 获得优惠卷的方法
    getCouponsInfo: function(num) {
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + this.hurl + "/user/coupon",
        dataType: "json",
        data: {
          type: num
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            this.couponNum = res.data.result.length;
          } else {
            this.showMsg(res.data.mag);
          }
        })
        .catch(() => {
          this.showMsg("系统错误,请稍后再试!");
        });
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/common.less";

.discount {
  .media;
  padding: 10px 0;
  .discount_count {
    width: 100%;
    height: 170px;
    text-align: center;
    padding-top: 20px;
    // padding-top: 30px;
    .box-sizing;
    h1 {
      font-weight: normal;
      height: 4.5rem;
      font-size: @font * 4;
      span {
        font-size: @font;
      }
    }
  }
}
.smallTitle {
  font-size: 1.2rem;
  padding-left: 20px;
}
.couponA {
  font-weight: 600;
  color: #802629;
}
.integralA {
  font-weight: 600;
  color: #7f7e84;
}
</style>
